import { useEffect, useState } from 'react'
import { api } from './api.ts'

export function ResetPassword() {
  const [token, setToken] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const tokenParam = params.get('token')
    if (tokenParam) {
      setToken(tokenParam)
    }
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (password !== confirmPassword) {
      setError('Passwords do not match')
      return
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters')
      return
    }

    try {
      await api.auth.resetPassword(token, password)
      setSuccess(true)
      setTimeout(() => {
        window.location.href = '/'
      }, 2000)
    }
    catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <div className="w-[100dvw] h-[100dvh] text-[#f0f0f0] flex items-center justify-center">
      <div className="bg-[#2a2a2a] rounded-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold mb-6 bg-gradient-to-br from-[#667eea] to-[#764ba2] bg-clip-text text-transparent">
          Reset Password
        </h1>

        {error && <div className="bg-red-500 text-white p-3 rounded mb-4">{error}</div>}
        {success && (
          <div className="bg-green-500 text-white p-3 rounded mb-4">
            Password reset successful! Redirecting to home...
          </div>
        )}

        {!success && (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-[#333] border border-[#444] rounded text-white"
              required
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-2 bg-[#333] border border-[#444] rounded text-white"
              required
            />
            <button
              type="submit"
              className="w-full px-4 py-2 bg-gradient-to-br from-[#667eea] to-[#764ba2] text-white rounded font-semibold hover:opacity-90"
            >
              Reset Password
            </button>
          </form>
        )}

        <div className="mt-4 text-center">
          <a href="/" className="text-[#667eea] hover:underline">
            Back to home
          </a>
        </div>
      </div>
    </div>
  )
}
